export class UpgradeAlreadyInProgressError extends Error {
  public constructor() {
    super()

    this.message = 'UPGRADE_ALREADY_IN_PROGRESS'
  }
}
